











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import HostPageLinkMixin from '@/mixin/HostPageLink'

@Component({
  mixins: [
    HostPageLinkMixin,
  ],
})
export default class CartLoginDefaultNote extends Vue {
  @Prop({ required: true })
  hostName: string
}
